// extracted by mini-css-extract-plugin
module.exports = {"numbers":"e_ul","numbersOne":"e_vl","numbersIconWrapper":"e_wl","numbersIcon":"e_xl","numbersTitle":"e_yl","numbersSubTitle":"e_zl"};